import { defineStore } from 'pinia'

export const useSearchStore = defineStore('search', {
  state: () => ({
    locationText: '',
    lat: null,
    lng: null,
    categoryId: '',
    startDate: '',
    endDate: '',
    dateMode: 'dates',
    monthSpan: 3,
    flexLength: 'Weekend',
    flexMonth: '',
    guests: {
      adults: 0,
      children: 0,
      infants: 0,
      pets: 0,
    },
  }),
  actions: {
    setLocation({ text, lat = null, lng = null }) {
      this.locationText = text || ''
      this.lat = lat
      this.lng = lng
    },
    setCategory(categoryId) {
      this.categoryId = categoryId || ''
    },
    setDates({ start, end, mode = 'dates', monthSpan = 3, flexLength = 'Weekend', flexMonth = '' }) {
      this.startDate = start || ''
      this.endDate = end || ''
      this.dateMode = mode
      this.monthSpan = monthSpan
      this.flexLength = flexLength
      this.flexMonth = flexMonth
    },
    setGuests(guests) {
      this.guests = { ...this.guests, ...guests }
    }
  }
})
